
  import { computed, defineComponent } from 'vue'
  import { useStore } from 'vuex'

  export default defineComponent({
    name: "AccordionFooter",
    setup(_: any, { emit }: any) {
      const rotateWords = () => emit("rotateWords")
      const store = useStore()
      const userID = computed(() => store.getters.userID)

      return { rotateWords, userID }
    },
  })
